import { gql, Variables } from 'graphql-request';
import type { MergeCartResponseResult } from '@types';

export interface MergeCartResponse {
  wCartMergeRestore: {
    result: MergeCartResponseResult
  }
}

export interface MergeCartVariables extends Variables {
  cartUid: string;
  token: string;
  siteId: string;
}

export const MERGE_CART_QUERY = gql`
  mutation mergeCart($cartUid: String!, $token: String!, $siteId: String!) {
    wCartMergeRestore(cartUid: $cartUid, token: $token, siteId: $siteId)
  }
`;
